export default [
  [`Размеры`, `S`, `M`, `L`],
  [`Рукав, A`, `73`, `78`, `83`],
  [`Длина изделия, B`, `101`, `106`, `111`],
  [`Ширина по низу, C`, `54`, `57`, `62`]
];
